const prefix = 'Customer';
const path = '/';

export default [
	{
		path: path,
		name: prefix + 'Home',
		component: () => import('@/views/Customer/Home.vue'),
		meta: {
			layout: 'CustomerMenuWithProfile2',
		},
	},
	{
		path: path + 'dang-nhap',
		name: prefix + 'Login',
		component: () => import('@/views/Customer/Login.vue'),
		meta: {
			layout: 'Menu',
		},
	},
	{
		path: path + 'customer/login-link',
		name: prefix + 'LoginLink',
		component: () => import('@/views/Customer/LoginLink.vue'),
		meta: {
			layout: 'Empty',
		},
	},
	{
		path: path + 'dang-ky',
		name: prefix + 'Register',
		component: () => import('@/views/Customer/SignupByPhone.vue'),
		meta: {
			layout: 'Empty',
		},
	},
	{
		path: '/dang-ky-thong-tin',
		name: 'CustomerInformation',
		component: () => import('@/views/Customer/Register.vue'),
		meta: {
			layout: 'CustomerRegister',
		},
	},
	{
		path: path + 'quen-mat-khau',
		name: prefix + 'ForgotPassword',
		component: () => import('@/views/Customer/ForgotPassword.vue'),
		meta: {
			layout: 'Menu',
		},
	},
	{
		path: path + 'khoi-phuc-mat-khau',
		name: prefix + 'ResetPassword',
		component: () => import('@/views/Customer/ResetPassword.vue'),
		meta: {
			layout: 'Menu',
		},
	},
	{
		path: path + 'thong-bao',
		name: prefix + 'Notification',
		component: () => import('@/views/Customer/Notify.vue'),
		meta: {
			layout: 'CustomerMenuWithProfile',
		},
	},
	{
		path: path + 'nguoi-dung',
		name: prefix + 'User',
		component: () => import('@/views/Customer/User.vue'),
		meta: {
			layout: 'CustomerMenuWithProfile',
		},
	},
	{
		path: '/ho-so',
		name: 'CustomerProfile',
		component: () => import('@/views/Customer/Profile.vue'),
		meta: {
			layout: 'CustomerMenuWithProfile',
		},
	},
	{
		path: path + 'danh-sach-dia-chi',
		name: prefix + 'AddressList',
		component: () => import('@/views/Customer/AddressList.vue'),
		meta: {
			layout: 'CustomerMenuWithProfile',
		},
	},
	{
		path: '/xac-minh',
		name: 'CustomerVerification',
		component: () => import('@/views/Customer/Verification.vue'),
		meta: {
			layout: 'Empty',
		},
	},
	{
		path: path + 'san-pham/:id/:name',
		name: prefix + 'ServiceDetail',
		component: () => import('@/views/Customer/ServiceDetail.vue'),
		meta: {
			layout: 'CustomerWithoutMenu',
		},
	},
	{
		path: path + 'san-pham/:id/:name/dat-lich-lai',
		name: prefix + 'Rebooking',
		component: () => import('@/views/Customer/ServiceDetail.vue'),
		props: {
			isAllowedToRebook: true,
		},
		meta: {
			layout: 'CustomerWithoutMenu',
		},
	},
	{
		path: path + 'lich-hen',
		name: prefix + 'BookingList',
		component: () => import('@/views/Customer/BookingList.vue'),
		meta: {
			layout: 'CustomerMenuWithProfile',
		},
	},
	{
		path: path + 'lich-hen/:id',
		name: prefix + 'BookingDetail',
		component: () => import('@/views/Customer/BookingDetail.vue'),
		meta: {
			layout: 'CustomerWithoutMenu',
		},
	},
	{
		path: path + 'goi-dich-vu/:id',
		name: prefix + 'ServicePackage',
		component: () => import('@/views/Customer/ServicePackage.vue'),
		meta: {
			layout: 'CustomerWithoutMenu',
		},
	},
	{
		path: path + 'dat-lich-goi-dich-vu/:id',
		name: prefix + 'ServicePackageBooking',
		component: () => import('@/views/Customer/ServicePackageBooking.vue'),
		meta: {
			layout: 'CustomerMenuWithProfile2',
		},
	},
	{
		path: path + 'dich-vu/:id',
		name: prefix + 'Services',
		component: () => import('@/views/Customer/Services.vue'),
		meta: {
			layout: 'CustomerMenuWithProfile',
		},
	},
	{
		path: path + 'dich-vu-xet-nghiem',
		name: prefix + 'HealthTestingService',
		component: () => import('@/views/Customer/HealthTestingService.vue'),
		meta: {
			layout: 'HealthTesting',
		},
	},
	{
		path: path + 'dich-vu-xet-nghiem/dat-lich-lai',
		name: prefix + 'RebookingBloodTest',
		component: () => import('@/views/Customer/HealthTestingService.vue'),
		props: {
			isAllowedToRebook: true,
		},
		meta: {
			layout: 'HealthTesting',
		},
	},
	{
		path: path + 'tim-kiem',
		name: prefix + 'Search',
		component: () => import('@/views/Customer/Search.vue'),
		meta: {
			layout: 'CustomerMenuWithProfile2',
		},
	},
	{
		path: path + 'xac-nhan-thanh-toan',
		name: prefix + 'PaymentCallback',
		component: () => import('@/views/Customer/PaymentCallback.vue'),
		meta: {
			layout: 'CustomerWithoutMenu',
		},
	},
	{
		path: path + 'gioi-thieu',
		name: prefix + 'About',
		component: () => import('@/views/Customer/About.vue'),
		meta: {
			layout: 'CustomerMenuWithProfile2',
		},
	},
	{
		path: path + 'danh-sach-dich-vu',
		name: prefix + 'ServicesList',
		component: () => import('@/views/Customer/ServicesList.vue'),
		meta: {
			layout: 'CustomerMenuWithProfile2',
		},
	},
	{
		path: path + 'blog',
		name: prefix + 'BlogList',
		component: () => import('@/views/Customer/Blog/List.vue'),
		meta: {
			layout: 'CustomerMenuWithProfile2',
		},
	},
	{
		path: path + 'blog/:slug',
		name: prefix + 'BlogDetail',
		component: () => import('@/views/Customer/Blog/Detail.vue'),
		meta: {
			layout: 'CustomerMenuWithProfile2',
		},
	},
	{
		path: path + 'tro-giup-qa',
		name: prefix + 'QaHelp',
		component: () => import('@/views/Customer/CustomPage.vue'),
		meta: {
			layout: 'CustomerMenuWithProfile2',
		},
	},
	{
		path: path + 'dieu-khoan-thanh-toan',
		name: prefix + 'TermPayment',
		component: () => import('@/views/Customer/Privacy/TermPayment.vue'),
		meta: {
			layout: 'CustomerWithoutMenu',
		},
	},
	{
		path: path + 'co-che-giai-quyet',
		name: prefix + 'CCGQ',
		component: () => import('@/views/Customer/Privacy/CCGQ.vue'),
		meta: {
			layout: 'CustomerWithoutMenu',
		},
	},
	{
		path: path + 'chinh-sach-bao-mat',
		name: prefix + 'CSBM',
		component: () => import('@/views/Customer/Privacy/CSBM.vue'),
		meta: {
			layout: 'CustomerWithoutMenu',
		},
	},
	{
		path: path + 'quy-che-hoat-dong',
		name: prefix + 'QCHD',
		component: () => import('@/views/Customer/Privacy/QCHD.vue'),
		meta: {
			layout: 'CustomerWithoutMenu',
		},
	},
	{
		path: path + 'chinh-sach-van-chuyen',
		name: prefix + 'CSVC',
		component: () => import('@/views/Customer/Privacy/CSVC.vue'),
		meta: {
			layout: 'CustomerWithoutMenu',
		},
	},
	{
		path: path + 'chinh-sach-huy-dich-vu',
		name: prefix + 'CSHDV',
		component: () => import('@/views/Customer/Privacy/CSHDV.vue'),
		meta: {
			layout: 'CustomerWithoutMenu',
		},
	},
	{
		path: path + 'chinh-sach-hoan-tien',
		name: prefix + 'CSHT',
		component: () => import('@/views/Customer/Privacy/CSHT.vue'),
		meta: {
			layout: 'CustomerWithoutMenu',
		},
	},
	{
		path: path + 'cau-chuyen-thuong-hieu',
		name: prefix + 'StoryBrand',
		component: () => import('@/views/Customer/StoryBrand.vue'),
		meta: {
			layout: 'CustomerMenuWithProfile2',
		},
	},
	{
		path: path + 'doi-ngu-nhan-vien',
		name: prefix + 'IntroStaff',
		component: () => import('@/views/Customer/IntroStaff.vue'),
		meta: {
			layout: 'CustomerMenuWithProfile2',
		},
	},
	{
		path: path + 'lien-he',
		name: prefix + 'Contact',
		component: () => import('@/views/Customer/Contact.vue'),
		meta: {
			layout: 'CustomerMenuWithProfile2',
		},
	},
	{
		path: path + 'dang-sach-ctv',
		name: prefix + 'ListNurse',
		component: () => import('@/views/Customer/ListNurse.vue'),
		meta: {
			layout: 'CustomerMenuWithProfile2',
		},
	},
	{
		path: path + 'payment',
		name: prefix + 'ListPaymentMethod',
		component: () => import('@/views/Customer/MethodPayment.vue'),
		meta: {
			layout: 'CustomerMenuWithProfile2',
		},
	},
];
